import Icon from 'components/Icon';
import './style.css';

const File = ({ file, deleteFile }) => {
	const fileName = file?.fileName;
	const fileType = file?.fileSFix;
	const fileData = file?.fileData;

	const handleDownloadClick = async () => {
		if (!fileData) return;
		// convert Base64 to raw binary data
		await fetch(`data:application/${fileType};base64,${fileData}`)
			.then(res => res.blob())
			.then(blob => {
				const blobUrl = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = `${fileName}`;
				document.body.appendChild(link); // Required for Firefox
				link.click();
				document.body.removeChild(link);
			});
	};

	return (
		<div className={`file ${(fileType && fileType) || ''}`}>
			<div className="file__wrapper">
				{fileType && <Icon icon={fileType === 'doc' || fileType === 'docx' ? 'wordIcon' : `${fileType}Icon`} size="31" />}
				<div className={`file__name`}>{fileName}</div>
				<div className="file__btn_wrapper">
					<Icon icon="downloadIcon" onClick={handleDownloadClick} size="15" color="#bababa" />
					{deleteFile && <Icon icon="trashIcon" size="15" color="#d41028" onClick={deleteFile} />}
				</div>
			</div>
		</div>
	);
};

export default File;
